import { useLanguage } from "../context/LanguageContext";

const Sparkle = ({ className = "" }) => (
  <svg className={className} viewBox="0 0 20 20" fill="none" aria-hidden="true">
    <path
      d="M10 0L11.5 8.5L20 10L11.5 11.5L10 20L8.5 11.5L0 10L8.5 8.5L10 0Z"
      fill="#C5A059"
    />
  </svg>
);

const Products = () => {
  const { t } = useLanguage();

  return (
    <section
      id="products"
      data-testid="products-section"
      className="relative py-24 md:py-32"
    >
      <div className="max-w-6xl mx-auto px-6 md:px-10">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between mb-14 md:mb-20 gap-6">
          <div>
            <div className="text-xs uppercase tracking-[0.25em] text-[var(--brand-gold)] mb-4">
              {t.products.eyebrow}
            </div>
            <h2 className="font-display text-[42px] md:text-[64px] leading-[1.05] max-w-2xl text-[var(--text-primary)]">
              {t.products.title}
            </h2>
          </div>
          <p className="max-w-md text-base text-[var(--text-secondary)] leading-relaxed">
            {t.products.subtitle}
          </p>
        </div>

        <FeaturedCard t={t} />
      </div>
    </section>
  );
};

const FeaturedCard = ({ t }) => (
  <div
    data-testid="product-featured-vitamin-water"
    className="relative rounded-[36px] p-8 md:p-14 overflow-hidden border border-[var(--bg-subtle)] bg-white"
  >
    <div
      aria-hidden="true"
      className="absolute inset-0 opacity-60"
      style={{
        background:
          "radial-gradient(circle at 85% 50%, var(--p-collagen) 0%, transparent 55%), radial-gradient(circle at 10% 10%, var(--p-immunity) 0%, transparent 45%)",
      }}
    />
    <Sparkle className="absolute top-8 end-10 w-5 h-5" />
    <Sparkle className="absolute bottom-12 start-12 w-4 h-4" />

    <div className="relative grid md:grid-cols-2 gap-10 md:gap-14 items-center">
      <div>
        <span
          data-testid="product-coming-soon-badge"
          className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-[10px] uppercase tracking-widest font-medium bg-[var(--text-primary)] text-[var(--bg-base)]"
        >
          <span className="w-1.5 h-1.5 rounded-full bg-[var(--brand-gold)]" />
          {t.products.coming_soon}
        </span>
        <h3 className="font-display text-4xl md:text-5xl lg:text-6xl text-[var(--text-primary)] mt-6 leading-[1.05]">
          {t.products.vw_title}
        </h3>
        <p className="mt-5 text-base md:text-lg text-[var(--text-secondary)] leading-relaxed max-w-md">
          {t.products.vw_desc}
        </p>
        <div className="mt-8 flex items-center gap-3 text-sm text-[var(--text-primary)]">
          <span className="inline-block w-8 h-px bg-[var(--brand-gold)]" />
          <span className="italic font-display">{t.products.vw_note}</span>
        </div>
      </div>

      <div className="relative">
        <div className="aspect-[4/3] rounded-3xl overflow-hidden bg-[var(--bg-subtle)] shadow-[0_24px_60px_-24px_rgba(44,48,46,0.25)]">
          <img
            src="https://customer-assets.emergentagent.com/job_d8bfe459-56db-4669-bf31-d95e5b70b8e8/artifacts/ibpribsk_IMG_8653.png"
            alt={t.products.vw_title}
            className="w-full h-full object-cover"
            loading="lazy"
            style={{ filter: "blur(16px) saturate(1.05)" }}
          />
        </div>
        {/* Centered Coming Soon plaque */}
        <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
          <div className="bg-[var(--text-primary)]/85 backdrop-blur-md px-7 py-4 rounded-full border border-[var(--brand-gold)]/40 shadow-2xl">
            <div className="flex items-center gap-3">
              <span className="w-2 h-2 rounded-full bg-[var(--brand-gold)]" />
              <span className="font-display text-lg md:text-xl text-[var(--bg-base)] tracking-wide">
                {t.products.coming_soon}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default Products;
